export const SERVER_SHOW_RESET = 'SERVER_SHOW_RESET'
export const SERVER_SHOW_SET_ERROR = 'SERVER_SHOW_SET_ERROR'
export const SERVER_SHOW_SET_RETRIEVED = 'SERVER_SHOW_SET_RETRIEVED'
export const SERVER_SHOW_TOGGLE_LOADING = 'SERVER_SHOW_TOGGLE_LOADING'
